import { colors, fonts } from '@grupoboticario/flora-tokens/altoContraste/web/ds';
export var altoContraste = {
  colors,
  fonts
};
//# sourceMappingURL=altoContraste.js.map